import {ConfigObjectType, loginContainer} from '@wallaby-ui/core';
import * as React from 'react';

type Props = {config: ConfigObjectType};
export const AuditReportsLayoutContainer: React.FC<Props> = (props) => {
  return <>TODO</>;
};
